import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-service-badge',
  templateUrl: './service-badge.component.html',
  styleUrls: ['./service-badge.component.scss']
})
export class ServiceBadgeComponent {
  @Input() service: string;
  @Input() text: string;
}
